import { RootState } from "../store";

export const selectPersonTypes = (state: RootState) => state.personTypes.list;
export const selectErrorMessagePersonTypes = (state: RootState) => state.personTypes.errorMessage;